/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { BreadcrumbsBox } from "~/components/BreadcrumbsBox";
import { ROUTES } from "~/routing/routes";
import { ApplicationCreateWizard } from "./components/ApplicationCreateWizard/ApplicationCreateWizard";

export function ApplicationCreate() {
  return (
    <>
      <BreadcrumbsBox
        title="Create Application"
        customBreadcrumbs={[
          { label: "Dashboard", uri: "/" },
          { label: "Applications", uri: ROUTES.applications.index },
          { label: "Create Application", uri: ROUTES.applications.create },
        ]}
      />
      <ApplicationCreateWizard />
    </>
  );
}
